import script from "./AppWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./AppWrapper.vue?vue&type=script&setup=true&lang=js"

import "./AppWrapper.vue?vue&type=style&index=0&id=0ad08c86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad08c86"]])

export default __exports__